import React, { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { AuthContext } from "../contexts/AuthContext";
import { ROOT_URL } from "../constants/routerUrl";

const PrivateRoute = ({ children }) => {
  const auth = useContext(AuthContext);
  const location = useLocation();

  if (auth.isLoggedIn) {
    return (
      <div className="app-container">
        <div className="main">
          {children}
        </div>
      </div>
    );
  } else {
    return (
      <Navigate
        to={ROOT_URL}
        state={{
          redirectUrl: location.pathname,
        }}
        replace
      />
    );
  }
};

export default PrivateRoute;
